import { render, staticRenderFns } from "./FormSmart.vue?vue&type=template&id=3986b474&scoped=true"
import script from "./FormSmart.vue?vue&type=script&lang=js"
export * from "./FormSmart.vue?vue&type=script&lang=js"
import style0 from "./FormSmart.vue?vue&type=style&index=0&id=3986b474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986b474",
  null
  
)

export default component.exports